<template>
  <v-container class="ma-2 ma-sm-12" fluid>
    <div class="mb-5 text-h5 font-weight-black _light_grey--text">{{ $t('deployApp') }}</div>
    <iframe :src="dashboardUrl" title="Dashboard" width="100%" height="800" frameborder="0"></iframe>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import User from '../store/user';

export default {
  name: 'DeployApp',
  data: () => ({
    encryptEmail: '',
  }),
  mounted() {
    this.encrypt();
  },
  computed: {
    ...mapState('authenticate', ['isSignIn', 'userAttribute']),
    ...mapGetters('locale', ['locale']),
    account() {
      if (!this.isSignIn) return '';
      return this.userAttribute.email;
    },
    dashboardUrl() {
      return `https://vmx-deployment-plan.s3.ap-northeast-1.amazonaws.com/index.html?email=${encodeURIComponent(this.encryptEmail)}&lang=${this.locale}#/`;
    },
  },
  methods: {
    async encrypt() {
      const value = await User.encrypt({ text: this.account });
      this.encryptEmail = value.data;
      // console.log(this.encryptEmail);
    },
  },
};
</script>
